__turbopack_context__.v({
  "className": "proximanovacond_aa1f823e-module__CgaBQa__className",
  "variable": "proximanovacond_aa1f823e-module__CgaBQa__variable",
});
